import { Box, Popover, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons } from "../../../../stack/environment/icons/iconExport";
import IntegrationImage from "../../../../stack/integrations/components/IntegrationImage";

const ViewSources = ({
  open,
  onClose,
  anchorEl,
  control_ids_and_sources = [],
}) => {
  const navigate = useNavigate();
  const colors = useColors();
  const { trackEvent } = useAPI();

  const navigateToControl = (controlId) => {
    trackEvent(
      `User navigated to control ${controlId} from MCP Servers widget`
    );
    navigate(`/posture/controls?control_id=${controlId}`);
    onClose();
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
            mt: 1,
          },
        },
      }}
    >
      <Box
        sx={{
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="overline">Sources</Typography>

        {control_ids_and_sources.length === 0 ? (
          <Typography variant="caption" color={colors.text_secondary}>
            No controls available
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            {control_ids_and_sources.map((control_id_and_source) => (
              <Box
                key={control_id_and_source.control_id}
                onClick={() =>
                  navigateToControl(control_id_and_source.control_id)
                }
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                <IntegrationImage
                  name={control_id_and_source?.source}
                  width="14px"
                  showToolTip={false}
                  newLogo={true}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: colors.primary_main,
                  }}
                >
                  #{control_id_and_source.control_id}
                </Typography>
                <SvgToIcon
                  IconLogo={icons.NewTabIcon}
                  width="16px"
                  style={{ color: colors.primary_main }}
                />
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Popover>
  );
};

export default ViewSources;
